/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon24Solid = forwardRef('TargetCrosshairIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm2.604-1.25a7.506 7.506 0 0 1 6.146-6.146V7.25a1.25 1.25 0 1 0 2.5 0V4.604a7.506 7.506 0 0 1 6.146 6.146H16.75a1.25 1.25 0 1 0 0 2.5h2.646a7.506 7.506 0 0 1-6.146 6.146V16.75a1.25 1.25 0 1 0-2.5 0v2.646a7.506 7.506 0 0 1-6.146-6.146H7.25a1.25 1.25 0 1 0 0-2.5H4.604Z" })));
});
